module.exports = __webpack_public_path__ + "img/collab-logo.0614a6ba.png";